import FuzzySearch from 'bloko/common/fuzzySearch';

const createStaticDataProvider = (array) => (query) => {
    const filterItems = ({ text }) => FuzzySearch.match(query, text);
    const items = array.filter(filterItems);

    return new Promise((resolve) => {
        setTimeout(() => resolve({ items }), 0);
    });
};

export default createStaticDataProvider;
